import BeautyImage from '@/assets/images/beauty.png';
import FashionImage from '@/assets/images/fashion.png';
import HomeImage from '@/assets/images/home.png';
import FoodImage from '@/assets/images/food.png';

export const SHOPPING_FEED = {
  beauty: {
    title: 'Beauty',
    image: BeautyImage,
    tags: ['Beauty', 'Makeup', 'Skincare', 'BeautyRoutine', 'Haircare', 'Glam'],
  },
  fashion: {
    title: 'Fashion',
    image: FashionImage,
    tags: ['Fashion', 'Accessories', 'Outfit', 'Clothing', 'Perfumes', 'Capsule'],
  },
  home: {
    title: 'Home',
    image: HomeImage,
    tags: ['Home', 'Kitchen', 'Decor', 'Bedroom', 'Bathroom', 'HomeOffice', 'Furniture'],
  },
  food: {
    title: 'Food',
    image: FoodImage,
    tags: ['Food', 'Groceries', 'Snacks', 'Wellness'],
  },
};
